import { render, staticRenderFns } from "./SuperTouchPc.vue?vue&type=template&id=24d7c13c&scoped=true&"
import script from "./SuperTouchPc.vue?vue&type=script&lang=js&"
export * from "./SuperTouchPc.vue?vue&type=script&lang=js&"
import style0 from "./SuperTouchPc.vue?vue&type=style&index=0&id=24d7c13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7c13c",
  null
  
)

export default component.exports